import { CommonModule } from '@angular/common'
import { Component, CUSTOM_ELEMENTS_SCHEMA, Input, OnInit } from '@angular/core'
import { RouterModule } from '@angular/router'
import { Subscription } from 'rxjs'
import { AngularMaterialsModules } from 'src/app/module/materials.module'
import { ThemeService } from 'src/app/service/theme/theme.service'
import { Themes } from '../../enums/enums'
import { DdcTextGradientComponent } from '../ddc-text-gradient/ddc-text-gradient.component'

@Component({
  selector: 'ddc-collection',
  templateUrl: './ddc-collection.component.html',
  styleUrl: './ddc-collection.component.scss',
  imports: [AngularMaterialsModules, CommonModule, RouterModule, DdcTextGradientComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class DdcCollectionComponent implements OnInit {
  @Input('elem') _elem: any
  @Input('dynamicRoute') _dynamicRoute: string

  _isLightTheme: boolean = true
  _isDarkTheme: boolean = false
  _isPaperTheme: boolean = false
  private themeSubscription: Subscription

  constructor(public themeService: ThemeService) {
    this.themeSubscription = this.themeService.theme$.subscribe(theme => {
      this._isLightTheme = theme === Themes.LIGHT
      this._isDarkTheme = theme === Themes.DARK
      this._isPaperTheme = theme === Themes.PAPER
    })
  }

  ngOnInit(): void {}
}
